import type { Commit, Dispatch } from 'vuex';

interface FilterBottomContent {
  componentName: string | null;
}
interface State {
  isOpened: boolean;
  showFilterButton: boolean;
  groups: object[];
  values: object;
  bottomContent: FilterBottomContent;
}

const state = (): State => ({
  isOpened: false,
  showFilterButton: false,
  groups: [],
  values: {},
  bottomContent: {
    componentName: null,
  },
});

const getters = {
  areGroupsEmpty: (state: State) => state.groups.length === 0,
};

const actions = {
  reset({ dispatch }: { dispatch: Dispatch }) {
    dispatch('toggleFilter', false);
    dispatch('resetGroups');
    dispatch('resetValues');
    dispatch('resetBottomContent');
  },
  resetGroups({ commit }: { commit: Commit }) {
    commit('SET_GROUPS', []);
  },
  resetValues({ commit }: { commit: Commit }) {
    commit('SET_VALUES', {});
  },
  resetBottomContent({ commit }: { commit: Commit }) {
    commit('SET_BOTTOM_CONTENT', {
      componentName: null,
    });
  },
  setGroups({ commit }: { commit: Commit }, groups: object[]) {
    commit('SET_GROUPS', groups);
  },
  setValues({ commit }: { commit: Commit }, values: object) {
    commit('SET_VALUES', values);
  },
  setBottomContent({ commit }: { commit: Commit }, payload: FilterBottomContent) {
    commit('SET_BOTTOM_CONTENT', payload);
  },
  setShowFilterButton({ commit }: { commit: Commit }, show: boolean) {
    commit('SET_SHOW_FILTER_BUTTON', show);
  },
  toggleFilter({ commit, dispatch }: { commit: Commit; dispatch: Dispatch }, isOpened: boolean) {
    if (isOpened && this.getters.isUserMembershipLapsed) {
      dispatch('renewMembershipModal/toggleModal', true);
      return;
    }
    commit('TOGGLE_FILTER', isOpened);
  },
};

const mutations = {
  SET_GROUPS(state: State, groups: object[]) {
    state.groups = groups;
  },
  SET_VALUES(state: State, values: object) {
    state.values = values;
  },
  SET_BOTTOM_CONTENT(state: State, payload: FilterBottomContent) {
    state.bottomContent = payload;
  },
  SET_SHOW_FILTER_BUTTON(state: State, show: boolean) {
    state.showFilterButton = show;
  },
  TOGGLE_FILTER(state: State, isOpened: boolean) {
    state.isOpened = isOpened;
  },
};

export default {
  namespaced: true,
  actions,
  state,
  getters,
  mutations,
};
